let messengerOpenRoomId = null;
let messengerVisible = false;

/** 채팅방 화면에 포커스된 방 id (목록·설정 등이면 null) */
export function setMessengerOpenRoomId(roomId) {
  messengerOpenRoomId = roomId ?? null;
}

export function getMessengerOpenRoomId() {
  return messengerOpenRoomId;
}

/** 채팅 위젯 자체가 열려있는지 (목록 포함) */
export function setMessengerVisible(visible) {
  messengerVisible = !!visible;
}

export function getMessengerVisible() {
  return messengerVisible;
}
